import { render, staticRenderFns } from "./CoursewareActionWidget.vue?vue&type=template&id=25b0fd2f&"
import script from "./CoursewareActionWidget.vue?vue&type=script&lang=js&"
export * from "./CoursewareActionWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports